import React from "react";
import { websiteBaseUrl } from "../../libraries/helper";

export default () => {
  return  <iframe className="iframeReport" src={`${websiteBaseUrl}/financial-report`} />;
};
